import { routes } from 'defs';
import { EventCustomFeedbackCodes, EventFeedbackCodes } from 'defs/events';
import { getTargetFromFactory, TargetActions, TargetTypes } from 'defs/notifications';

const targets = {
	[EventCustomFeedbackCodes.LoginLeaving]: {
		primary: {
			type: TargetTypes.Close,
		},
	},
	[EventCustomFeedbackCodes.Error500]: {
		primary: {
			type: TargetTypes.Reload,
		},
	},
	[EventCustomFeedbackCodes.Error408]: {
		primary: {
			type: TargetTypes.Reload,
		},
	},
	[EventCustomFeedbackCodes.Offline]: {},
	[EventCustomFeedbackCodes.ValidationError]: {
		primary: {
			type: TargetTypes.Route,
			value: { href: routes.anamnesis.indexRoute.href },
		},
	},
	[EventCustomFeedbackCodes.Dsgvo]: {
		primary: {
			type: TargetTypes.Action,
			value: { action: TargetActions.SaveDsgvo },
		},
	},
	[EventCustomFeedbackCodes.DsgvoReminder]: {
		primary: {
			type: TargetTypes.Action,
			value: { action: TargetActions.SaveDsgvo },
		},
	},
	[EventCustomFeedbackCodes.Z02]: {
		primary: {
			type: TargetTypes.Reload,
		},
		secondary: {
			type: TargetTypes.ExternalHrefWithReload,
		},
	},
	[EventFeedbackCodes.F04]: {
		primary: {
			callbackId: 'replace',
			type: TargetTypes.Action,
			value: { action: TargetActions.ReplaceProgram },
		},
		secondary: {
			type: TargetTypes.Close,
		},
	},
	[EventFeedbackCodes.F05]: {
		primary: {
			callbackId: 'confirm',
			type: TargetTypes.Action,
			value: { action: TargetActions.OverwriteProgram },
		},
		secondary: {
			type: TargetTypes.Route,
			value: { href: routes.program.recommended.href },
		},
	},
	[EventFeedbackCodes.F06]: {
		primary: {
			type: TargetTypes.RouteAction,
			value: { href: routes.today.indexRoute.href, action: TargetActions.SaveParticipateCompetition },
		},
	},
	[EventFeedbackCodes.F07]: {
		primary: {
			type: TargetTypes.Route,
			value: { href: routes.anamnesis.selectCoach.href },
		},
	},
	[EventFeedbackCodes.F08]: {
		primary: {
			type: TargetTypes.Route,
			value: { href: routes.anamnesis.selectCoach.href },
		},
	},
	[EventFeedbackCodes.F09]: {
		primary: {
			type: TargetTypes.Close,
		},
	},
	[EventFeedbackCodes.F10]: {
		primary: {
			type: TargetTypes.LoginButton,
		},
	},
	[EventFeedbackCodes.F11]: {
		primary: {
			type: TargetTypes.Route,
			value: { href: routes.anamnesis.selectCoach.href },
		},
	},
	[EventFeedbackCodes.F12]: {
		primary: {
			type: TargetTypes.Close,
		},
	},
};

export const get = (key: string) => getTargetFromFactory(targets as any, key);

export default targets;
